import {Component, ViewEncapsulation} from '@angular/core';
import {BaseComponent} from "../../shared/bases/base-component";
import {Observable} from "rxjs";
import {Serializer} from "../../shared/interfaces/serializer";
import { Space } from 'src/app/shared/interfaces/space';
import {Store} from "@ngrx/store";
import {AppState} from "../../shared/store/store";
import {selectSpace} from "../../shared/store/init/init.selectors";

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SubscriptionComponent extends BaseComponent {
  public readonly space$: Observable<Serializer<Space>> = this._store.select(selectSpace);

  constructor(private readonly _store: Store<AppState>) {
    super();
  }
}
